import React, { useState, useEffect } from "react";

import { Link } from "react-router-dom";
import AuthModal from "./AuthModal";
import { auth } from "./firebase";
import { signOut } from "firebase/auth";
import "./Navbar.css";

function Navbar({
  user,
  setUser,
  hideAuth = false,
  defaultShowAuth = false,
  onAuthModalClose,
  onAuthModalOpen,
}) {
  const [showAuth, setShowAuth] = useState(defaultShowAuth);

  useEffect(() => {
    setShowAuth(defaultShowAuth);
  }, [defaultShowAuth]);

  const handleOpenAuth = () => {
    setShowAuth(true);
    if (onAuthModalOpen) {
      onAuthModalOpen();
    }
  };

  const handleCloseAuth = () => {
    setShowAuth(false);
    if (onAuthModalClose) {
      onAuthModalClose();
    }
  };

  const handleLogout = async () => {
    try {
      await signOut(auth);
      if (setUser) {
        setUser(null);
      }
    } catch (error) {
      console.error("Error al cerrar sesión:", error);
    }
  };

  return (
    <header className="navbar-container">
      <div className="navbar-blur" aria-hidden="true" />
      <div className="navbar-inner">
        <div className="navbar-logo">
          <Link to="/" className="logo-link">
            <img
              src="/logo_512_t.png"
              alt="Avísame Si Baja"
              className="navbar-logo-image"
            />
            <div className="navbar-copy">
              <h1 className="navbar-title">Avísame Si Baja</h1>
              <p className="navbar-subtitle desktop-only">
                Automatiza tus alertas de precio en Amazon
              </p>
            </div>
          </Link>
        </div>

        <nav className="navbar-links" aria-label="Navegación principal">
          <a href="/novedades/" className="navbar-link navbar-blog-link">
            Novedades
          </a>
        </nav>

        <div className="navbar-actions">
          {user ? (
            <div className="user-section">
              <span className="user-email desktop-only">{user.email}</span>
              <button
                onClick={handleLogout}
                className="logout-button"
                aria-label="Cerrar sesión"
              >
                Cerrar sesión
              </button>
            </div>
          ) : (
            !hideAuth && (
              <button
                className="login-button"
                onClick={handleOpenAuth}
              >
                Iniciar sesión
              </button>
            )
          )}
        </div>
      </div>

      {showAuth && (
        <AuthModal onClose={handleCloseAuth} setUser={setUser} />
      )}
    </header>
  );
}

export default Navbar;
